import serviceTypeCodes from 'constants/serviceTypeCodes';

export const isEurostarOffer = (legs = []) => {
  if (legs.length > 0) {
    return legs.some((leg) => leg?.serviceType?.code === serviceTypeCodes.EUROSTAR);
  }

  return false;
};
